import React, { useEffect } from "react";

const AnimatedBackground = () => {
  useEffect(() => {
    const createParticle = () => {
      const particle = document.createElement("div");
      particle.classList.add("particle");

      const size = Math.random() * 5 + 2;
      particle.style.width = `${size}px`;
      particle.style.height = `${size}px`;

      const x = Math.random() * window.innerWidth;
      const y = window.innerHeight;
      particle.style.left = `${x}px`;
      particle.style.top = `${y}px`;

     const hue = Math.random() * 360;
     particle.style.backgroundColor = `hsl(${hue}, 100%, 50%)`;

      const duration = Math.random() * 3 + 2;
      particle.style.animation = `float-up ${duration}s linear`;

      document.getElementById("particles")?.appendChild(particle);

      setTimeout(() => {
        particle.remove();
      }, duration * 1000);
    };

    const interval = setInterval(createParticle, 50);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div
        id="particles"
        className="absolute inset-0 z-0 pointer-events-none"
      ></div>
      <style>{`
        .bg-animated {
          background: linear-gradient(-45deg, #000000, #1a1a1a, #000033, #003366);
          background-size: 400% 400%;
          animation: gradient 15s ease infinite;
        }

        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        .particle {
          position: absolute;
          border-radius: 50%;
        }

        @keyframes float-up {
          to {
            transform: translateY(-100vh) rotate(360deg);
            opacity: 0;
          }
        }
      `}</style>
    </>
  );
};

export default AnimatedBackground;
